var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.5 13.75C10.9518 13.75 13.75 10.9518 13.75 7.5C13.75 4.04822 10.9518 1.25 7.5 1.25C4.04822 1.25 1.25 4.04822 1.25 7.5C1.25 10.9518 4.04822 13.75 7.5 13.75Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.59375C7.75625 8.59375 7.96875 8.38125 7.96875 8.125V5C7.96875 4.74375 7.75625 4.53125 7.5 4.53125C7.24375 4.53125 7.03125 4.74375 7.03125 5V8.125C7.03125 8.38125 7.24375 8.59375 7.5 8.59375Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.075 9.7623C8.04375 9.6873 8 9.61855 7.94375 9.55605C7.88125 9.4998 7.8125 9.45605 7.7375 9.4248C7.5875 9.3623 7.4125 9.3623 7.2625 9.4248C7.1875 9.45605 7.11875 9.4998 7.05625 9.55605C7 9.61855 6.95625 9.6873 6.925 9.7623C6.89375 9.8373 6.875 9.91855 6.875 9.9998C6.875 10.0811 6.89375 10.1623 6.925 10.2373C6.95625 10.3186 7 10.3811 7.05625 10.4436C7.11875 10.4998 7.1875 10.5436 7.2625 10.5748C7.3375 10.6061 7.41875 10.6248 7.5 10.6248C7.58125 10.6248 7.6625 10.6061 7.7375 10.5748C7.8125 10.5436 7.88125 10.4998 7.94375 10.4436C8 10.3811 8.04375 10.3186 8.075 10.2373C8.10625 10.1623 8.125 10.0811 8.125 9.9998C8.125 9.91855 8.10625 9.8373 8.075 9.7623Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b3d132ec8433ca506e3c78043f03ca35.svg";
export { ForwardRef as ReactComponent };